import axios from 'axios';

let pendingPromise = null;

export const refreshToken = async () => {
    if (pendingPromise) {
        return await pendingPromise;
    }

    pendingPromise = new Promise((resolve, reject) => {
        // Оборачиваем логику в async-функцию
        const refresh = async () => {
            try {
                const response = await axios.post('/auth/refresh-token', {});
                if (!response.data) {
                    reject(new Error('No data in response'));
                    return;
                }
                resolve(response.data);
            } catch (error) {
                reject(error);
            } finally {
                pendingPromise = null;
            }
        };

        refresh();
    });

    return await pendingPromise;
};